"use client"

import { ParseWagmiError } from "util/cryptocurrency"
import { CompletedCollectible, DraftCollectible } from "@/types/collectibles"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import {
  useCreateSimulateTxnNewNFT,
  useCreateSimulateTxnExistingNFT,
} from "@/app/@modal/[blogSlug]/(.)nft/hooks/useCreateSimulateTxn"
import MintPriceText from "@/app/@modal/[blogSlug]/(.)nft/components/MintPriceText"

export default function TxnError({
  simulateData,
  collectible,
  className,
}: {
  simulateData: ReturnType<
    typeof useCreateSimulateTxnNewNFT | typeof useCreateSimulateTxnExistingNFT
  >
  collectible: DraftCollectible | CompletedCollectible
  className?: string
}) {
  if (simulateData.error) {
    const error = ParseWagmiError(simulateData.error)
    return (
      <>
        <p className="text-sm my-2 text-gray-500 text-center font-semibold max-w-[430px] overflow-auto">
          {error.msg}
        </p>

        <Button
          disabled
          className={cn(
            "w-full disabled:opacity-50 disabled:cursor-not-allowed",
            className
          )}
        >
          {error.msgShort ? (
            error.msgShort
          ) : (
            <MintPriceText collectible={collectible} />
          )}
        </Button>
      </>
    )
  }

  if (!simulateData.data && !simulateData.isLoading) {
    return (
      <p className="text-sm my-2 text-gray-500">
        An unknown error occurred. Try minting again.
      </p>
    )
  }

  return null
}
